import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy, Currency } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

const UnitsDetail = ({ units, quotaPrice, totalPrice, name, brand }) => (
    <Box>
        <Flex justifyContent='space-between' w='100%'>
            <Box>
                <Flex w='100%' height='100%'>
                    <Flex
                      alignItems={['top', 'center']}
                      justifyContent='center'>
                        <img height='50px' alt='Via-T' src={`/images/products/product_${brand}.webp`} />
                    </Flex>
                    <Box p='0 0 0 10px' height='100%'>
                        <Copy
                          padding='0'
                          fontSize='small'
                          fontWeight='medium'
                          color='gray'
                          transform='uppercase'
                            >{ name }</Copy>
                        <Copy
                          fontSize='small'
                          fontWeight='regular'
                          padding='5px 0 0 0'
                            ><Currency qty={quotaPrice} />
                            {'/'}<FormattedMessage defaultMessage='año' /> <FormattedMessage defaultMessage='+ IVA' />
                        </Copy>
                        <Box display={['block', 'none']}>
                            <Box mt='5px'>
                                <Copy as='span'
                                  padding='0'
                                  fontSize='small'
                                  fontWeight='medium'
                                  color='gray'
                                  transform='uppercase'>
                                    <FormattedMessage defaultMessage='Unidades' />
                                </Copy><Copy as='span'
                                  padding='0 0 0 10px'
                                  fontSize='small'
                                  fontWeight='regular'
                                  textAlign='center'
                                    >{units}
                                </Copy>
                            </Box>
                            <Box mt='5px'>
                                <Copy
                                  as='span'
                                  padding='0'
                                  fontSize='small'
                                  fontWeight='medium'
                                  color='gray'
                                  transform='uppercase'>
                                    <FormattedMessage defaultMessage='Total' />
                                </Copy><Copy
                                  as='span'
                                  padding='0 0 0 10px'
                                  fontSize='small'
                                  fontWeight='regular'
                                    ><Currency qty={totalPrice} />
                                </Copy>
                            </Box>
                        </Box>
                    </Box>
                </Flex>
            </Box>
            <Box display={['none', 'block']} mb='5px'>
                <Copy
                  padding='0'
                  fontSize='small'
                  fontWeight='medium'
                  color='gray'
                  textAlign='center'
                  transform='uppercase'>
                    <FormattedMessage defaultMessage='Unidades' />
                </Copy>
                <Copy
                  padding='5px 0 0 0'
                  fontSize='small'
                  fontWeight='regular'
                  textAlign='center'
                    >{units}
                </Copy>
            </Box>
            <Box display={['none', 'block']}>
                <Copy
                  padding='0'
                  fontSize='small'
                  fontWeight='medium'
                  color='gray'
                  textAlign='center'
                  transform='uppercase'>
                    <FormattedMessage defaultMessage='Total' />
                </Copy>
                <Copy
                  padding='5px 0 0 0'
                  fontSize='small'
                  fontWeight='regular'
                  textAlign='center'
                    ><Currency qty={totalPrice} />
                </Copy>
            </Box>
        </Flex>
    </Box>
)

UnitsDetail.defaultProps = {
    strech: false,
    disabled: false,
}

UnitsDetail.propTypes = {
    units: PropTypes.number.isRequired,
    brand: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quotaPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }).isRequired,
    totalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }).isRequired,
}

export default UnitsDetail
